<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn class="v-primary mb-1" v-on:click="handleModalCreate">
          <span class="fa fa-plus mr-2"></span> NOVO
        </v-btn>
        <b-modal id="create" hide-footer no-close-on-backdrop>
          <template v-slot:modal-title>NOVO TIPO DE COBRANÇA</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12">
                    <LabelRequiredField label="Valor" />
                    <input type="text" v-model="value" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="mr-2 fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <v-card>
          <v-card-title> TIPO DE COBRANÇA </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="billing_type_of_hosting_type"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <b-modal :id="String(item.id)" hide-footer no-close-on-backdrop>
                <template v-slot:modal-title>EDITAR TIPO DE COBRANÇA</template>
                <div class="d-block">
                  <div class="container">
                    <form v-on:submit="update" method="post">
                      <div class="row">
                        <WarningRequiredFields />
                        <ErrorsMessages :errors="errors" />
                        <div class="col-md-12">
                          <LabelRequiredField label="Nome" />
                          <input
                            type="text"
                            v-model="name"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-12">
                          <LabelRequiredField label="Valor" />
                          <input
                            type="text"
                            v-model="value"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-12 text-right">
                          <v-btn
                            class="v-primary m-1"
                            @click="$bvModal.hide(String(item.id))"
                          >
                            <span class="fa fa-arrow-left"></span> Voltar
                          </v-btn>
                          <v-btn
                            :disabled="loadingUpdate"
                            type="submit"
                            class="v-success m-1"
                          >
                            <span class="mr-2 fa fa-check"></span>
                            {{ loadingUpdate ? "Carregando" : "Salvar" }}
                          </v-btn>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </b-modal>
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import WarningRequiredFields from "../templates/components/WarningRequiredFields";

import LabelRequiredField from "../templates/components/LabelRequiredField";

import api from "../services/api";

import toast from "../components/ToastNotification";

export default {
  name: "ActiveIngredient",

  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      search: "",

      headers: [
        { text: "Nome", value: "name", sortable: false },
        { text: "Valor", value: "value", sortable: false },
        { align: "end", text: "", value: "edit", sortable: false },
      ],

      billing_type_of_hosting_type: [],

      id: "",
      name: "",
      value: "",

      loadingCreate: false,
      loadingUpdate: false,
      loading: true,

      errors: [],
    };
  },

  created() {
    this.paginate();
  },

  methods: {
    handleClickRowTable(item) {
      this.errors = [];
      this.id = item.id;
      this.name = item.name;
      this.value = item.value;
      this.$bvModal.show(String(item.id));
    },

    async paginate() {
      try {
        this.loading = true;

        const response = await api.get("/admin/billing-type-of-hosting-type");

        const { billing_type_of_hosting_type } = response.data;

        this.billing_type_of_hosting_type = billing_type_of_hosting_type;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name, value } = this;

        let params = {
          name,
          value,
        };

        const response = await api.post(
          "/admin/billing-type-of-hosting-type",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.paginate();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name, value } = this;

        let params = {
          id,
          name,
          value,
        };

        const response = await api.put(
          "/admin/billing-type-of-hosting-type",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.paginate();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.value = "";
      this.$bvModal.show("create");
    },
  },
};
</script>